import { useState } from "react";
import { useNavigate } from "react-router-dom";
import supabase from "../config/supabaseClient";

const Create = () => {
  const navigate = useNavigate();

  const [Name, setName] = useState('');
  const [Birth_date, setBirth_date] = useState('');
  const [Number, setNumber] = useState('');
  const [Phone_Number, setPhone_Number] = useState('');
  const [Zone, setZone] = useState('');
  const [Position, setPosition] = useState('');
  const [formError, setFormError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!Name || !Birth_date || !Number || !Phone_Number || !Zone || !Position) {
      setFormError('Please fill in all the fields correctly.');
      return;
    }

    try {
      const { data, error } = await supabase
        .from('players')
        .insert([{ Name, Birth_date, Number, Phone_Number, Zone, Position }])
        .select(); // important so we get back the inserted player_id

      if (error) {
        console.error('Supabase error:', error);
        setFormError('Error inserting the data. ' + (error.message || 'Unknown error'));
      } else {
        const newPlayer = data[0];
        console.log('Insert successful:', newPlayer);
        setFormError(null);

        // Go to AssignYear page with the new player id
        navigate(`/assign-year/${newPlayer.id}`, { replace: true });
      }
    } catch (err) {
      console.error('Unexpected error:', err);
      setFormError('Unexpected error occurred. ' + (err.message || 'Unknown error'));
    }
  };

  return (
    <div className="page create">
      <form onSubmit={handleSubmit}>

        <label htmlFor="Name">Name:</label>
        <input 
          type="text"
          id="Name"
          value={Name}
          onChange={(e) => setName(e.target.value)}
        />

        <label htmlFor="Birth_date">Birth Date:</label>
        <input 
          type="date"
          id="Birth_date"
          value={Birth_date}
          onChange={(e) => setBirth_date(e.target.value)}
        />

        <label htmlFor="Number">Number:</label>
        <input 
          type="number"
          id="Number"
          value={Number}
          onChange={(e) => setNumber(e.target.value)}
        />

        <label htmlFor="Phone_Number">Phone Number:</label>
        <input 
          type="number"
          id="Phone_Number"
          value={Phone_Number}
          onChange={(e) => setPhone_Number(e.target.value)}
        />

        <label htmlFor="Zone">Zone:</label>
        <input 
          type="text"
          id="Zone"
          value={Zone}
          onChange={(e) => setZone(e.target.value)}
        />

        <label htmlFor="Position">Position:</label>
        <input 
          type="text"
          id="Position"
          value={Position}
          onChange={(e) => setPosition(e.target.value)}
        />

        <button>Create Player</button>

        {formError && <p className="error">{formError}</p>}
      </form>
    </div>
  );
};

export default Create;
